<div class="categories-list-skeleton">
    <!-- Header -->
    <div class="row mb-3">
        <div class="col-12 col-sm-7 align-items-center">
            <app-skeleton-rect width="150px" height="28px" class="mb-2 d-block"></app-skeleton-rect>
            <app-skeleton-rect width="120px" height="16px" class="d-block"></app-skeleton-rect>
        </div>
        <div class="col-12 col-sm d-flex justify-content-end align-items-center">
            <app-skeleton-rect width="120px" height="38px" [borderRadius]="'8px'"></app-skeleton-rect>
        </div>
    </div>

    <!-- Table Card -->
    <div class="card">
        <div class="card-header">
            <div class="d-flex justify-content-between align-items-center">
                <app-skeleton-rect width="300px" height="38px"></app-skeleton-rect>
                <app-skeleton-rect width="150px" height="32px"></app-skeleton-rect>
            </div>
        </div>

        <div class="card-body pt-3">
            <!-- Table Header -->
            <div class="table-header d-flex align-items-center py-2 px-2 mb-2">
                <app-skeleton-rect width="300px" height="18px" class="me-auto"></app-skeleton-rect>
                <app-skeleton-rect width="100px" height="18px" class="me-4"></app-skeleton-rect>
                <app-skeleton-rect width="80px" height="18px"></app-skeleton-rect>
            </div>

            <!-- Table Rows -->
            <ng-container *ngFor="let i of [0,1,2,3,4]">
                <div class="table-row d-flex align-items-center py-3 px-2">
                    <!-- Category Name with tree indent -->
                    <div class="d-flex align-items-center me-auto" [style.padding-left.px]="(i % 3) * 20">
                        <app-skeleton-rect width="16px" height="16px" class="me-2"></app-skeleton-rect>
                        <app-skeleton-rect [width]="(200 - (i % 3) * 30) + 'px'" height="18px"></app-skeleton-rect>
                    </div>
                    <!-- Status -->
                    <app-skeleton-rect width="90px" height="24px" [borderRadius]="'12px'"
                        class="me-4"></app-skeleton-rect>
                    <!-- Actions -->
                    <app-skeleton-rect width="24px" height="24px"></app-skeleton-rect>
                </div>
            </ng-container>

            <!-- Pagination -->
            <div class="d-flex justify-content-between align-items-center mt-3 pt-3 border-top">
                <app-skeleton-rect width="180px" height="16px"></app-skeleton-rect>
                <div class="d-flex gap-2">
                    <app-skeleton-rect width="80px" height="32px" [borderRadius]="'6px'"></app-skeleton-rect>
                    <app-skeleton-rect width="32px" height="32px" [borderRadius]="'6px'"></app-skeleton-rect>
                    <app-skeleton-rect width="32px" height="32px" [borderRadius]="'6px'"></app-skeleton-rect>
                    <app-skeleton-rect width="80px" height="32px" [borderRadius]="'6px'"></app-skeleton-rect>
                </div>
            </div>
        </div>
    </div>
</div>